import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { TAMANIOS_REPRESENTION_IMPRESA_LIST } from "utils";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import RadioGroup from "components/RadioGroup/RadioGroup";
import ToolTip from "components/ToolTip/ToolTip";
import { SvgComponent } from "components";

const TOGGLE_OPCIONES = [
  {
    name: "EnviarRepresentacionImpresaAutomatica",
    label: "Enviar Automaticamente vía Email",
    tooltip:
      "Si se activa, el comprobante se envía automáticamente al correo del receptor al ser emitido.",
  },
  {
    name: "UtilizarDescripcionRepresentacionImpresa",
    label: "Utilizar Item Descripción",
    tooltip:
      "Muestra la descripción del item en la representación impresa.",
  },
  {
    name: "MostrarColumnaDescuentoDetalles",
    label: "Mostrar Columna Descuento en Detalles",
    tooltip:
      "Agrega la columna de descuento al detalle de la representación impresa.",
  },
  {
    name: "MostrarColumnaRecargoDetalles",
    label: "Mostrar Columna Recargo en Detalles",
    tooltip:
      "Agrega la columna de recargo al detalle de la representación impresa.",
  },
  {
    name: "MostrarRetencionesEnTotales",
    label: "Mostrar Retenciones en Totales",
    tooltip:
      "Incluye las retenciones en la sección de totales de la representación impresa.",
  },
  {
    name: "UtilizarDescripcionNombreItem",
    label: "Utilizar Nombre item y Descripción item",
    tooltip:
      "Muestra tanto el nombre como la descripción del item en la representación impresa.",
  },
  {
    name: "MostrarCodigoInternoComprador",
    label: "Mostrar Código Interno Comprador",
    tooltip:
      "Muestra el código interno del comprador en la representación impresa.",
  },
];

function ToggleRow({ name, label, tooltip, checked, onChange }) {
  return (
    <div
      className="d-flex align-items-center justify-content-between py-2"
      style={{ borderBottom: "1px solid #f0f0f0" }}
    >
      <div className="d-flex align-items-center">
        <span>{label}</span>
        <ToolTip message={tooltip} placement="top">
          <span
            className="ml-2"
            style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
          >
            <SvgComponent iconName="info" fill="#1E88E5" />
          </span>
        </ToolTip>
      </div>
      <Form.Check
        type="switch"
        id={`sw-${name}`}
        name={name}
        checked={!!checked}
        onChange={onChange}
        label=""
      />
    </div>
  );
}

export default function RepresentacionImpresaTab({ compania, setCompania, setCheckedProp }) {
  compania.TamanoRepresentacionImpresa = compania.TamanoRepresentacionImpresa
    ? compania.TamanoRepresentacionImpresa
    : TAMANIOS_REPRESENTION_IMPRESA_LIST[0].value;

  return (
    <div className="px-3 pb-4">
      <EditSection title="Formato de Impresión" style={{}}>
        <InputContainer stacked label="Tamaño Representación Impresa">
          <SectionRow>
            <RadioGroup
              options={TAMANIOS_REPRESENTION_IMPRESA_LIST}
              selectedOption={compania.TamanoRepresentacionImpresa}
              onChange={(e) =>
                setCompania({
                  ...compania,
                  TamanoRepresentacionImpresa: e.target.value,
                })
              }
            />
          </SectionRow>
        </InputContainer>

        <Row className="mx-0 mt-3">
          <Col xs={12} md={10} lg={9} className="px-0">
            {TOGGLE_OPCIONES.map((opt) => (
              <ToggleRow
                key={opt.name}
                name={opt.name}
                label={opt.label}
                tooltip={opt.tooltip}
                checked={compania[opt.name]}
                onChange={setCheckedProp}
              />
            ))}
          </Col>
        </Row>
      </EditSection>
    </div>
  );
}
